import { render, staticRenderFns } from "./StatisticsSystemStatusCurrencies.vue?vue&type=template&id=115d044a&scoped=true&"
import script from "./StatisticsSystemStatusCurrencies.vue?vue&type=script&lang=js&"
export * from "./StatisticsSystemStatusCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsSystemStatusCurrencies.vue?vue&type=style&index=0&id=115d044a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d044a",
  null
  
)

export default component.exports